import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';


const PieFeedback = ({data, title}) =>{

  

    const mockdata =[
      {name:1, value:10},
      {name:2, value:12},
      {name:3, value:39},
      {name:4, value:41},
      {name:5, value:52},
    ]


    return(<>
            <h4>{title}</h4>
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie data={data || mockdata } dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={60} innerRadius={30} label>
                  <Cell fill={"#e34432"} name="1⭐"/>
                  <Cell fill={"#e37c32"} name="2⭐"/>
                  <Cell fill={"#e3ce32"} name="3⭐"/>
                  <Cell fill={"#96e332"} name="4⭐"/>
                  <Cell fill={"#32a2e3"} name="5⭐"/>
                </Pie>
                <Tooltip />
                <Legend/>
              </PieChart>
            </ResponsiveContainer>
        </>)

}


export default PieFeedback